import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  static targets = ['svgElement', 'tooltipTriggerWrapper', 'barReferenceLine']

  declare readonly svgElementTarget: SVGElement
  declare readonly tooltipTriggerWrapperTarget: HTMLDivElement
  declare readonly hasSvgElementTarget: boolean
  declare readonly hasTooltipTriggerWrapperTarget: boolean
  declare readonly barReferenceLineTargets: HTMLDivElement[]
  declare readonly hasBarReferenceLineTarget: boolean

  connect(): void {
    if (this.hasSvgElementTarget && this.hasTooltipTriggerWrapperTarget) {
      const bounds = this.svgElementTarget.getBoundingClientRect()
      this.tooltipTriggerWrapperTarget.style.width = bounds.width + 'px'
      this.tooltipTriggerWrapperTarget.style.height = bounds.height + 'px'
    } else if (this.hasBarReferenceLineTarget) {
      this.barReferenceLineTargets.forEach(line => {
        line.style.width = line.clientWidth + 'px'
        line.classList.add('absolute')
      })
    }
  }

  hover(e: MouseEvent): void {
    if (!this.hasSvgElementTarget || !this.hasTooltipTriggerWrapperTarget) return

    const trigger = e.target as HTMLDivElement
    const index = parseInt(trigger.dataset.index ?? '0', 10)
    const circle = this.svgElementTarget.querySelectorAll('circle').item(index)
    const isIn = e.type === 'mouseenter'
    circle?.classList.toggle('opacity-0', !isIn)
  }
}
